import Component from '../app/component';

export default class extends Component {
  constructor(el) {
    super(el);
    this.data = {
      click: false,
      display: false,
      position: {
        x: 0,
        y: 0
      }
    };
  }

  init() {
    this.el.classList.add('cursor--transition');

    window.addEventListener('mousemove', (e) => {
      this.data.position = {
        x: e.clientX,
        y: e.clientY
      };
    });
    document.body.addEventListener('cursor.display', () => {
      this.data.display = true;
    });
    document.body.addEventListener('cursor.hide', () => {
      this.data.display = false;
    });
    document.body.addEventListener('cursor.click', () => {
      this.data.click = true;
    });
    document.body.addEventListener('cursor.unclick', () => {
      this.data.click = false;
    });
  }

  watchDisplay(value) {
    if (value) {
      this.el.classList.add('cursor--active');
    } else {
      this.el.classList.remove('cursor--active');
    }
  }

  watchClick(value) {
    if (value) {
      this.el.classList.add('cursor--click');
    } else {
      this.el.classList.remove('cursor--click');
    }
  }

  watchPosition(value) {
    this.el.style.top = `${value.y}px`;
    this.el.style.left = `${value.x}px`;
  }
}
